import { Button, Space } from "antd";
import { useIntl } from "react-intl";
import PermissionCheck from "~Common/PermissionCheck";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import { DeleteBroadcastAction } from "~pages/Fixtures/BroadcastPage/components/Actions/DeleteBroadcastAction.tsx";
import { EditBroadcastAction } from "~pages/Fixtures/BroadcastPage/components/Actions/EditBroadcastAction.tsx";
import type { BroadcastTableRow } from "~pages/Fixtures/BroadcastPage/types/broadcastTableRow.ts";

type Props = {
  editableRow: number | null;
  row: BroadcastTableRow;
  onSave: () => Promise<void>;
  onDiscard: () => void;
  handleDelete: (broadcast: BroadcastTableRow) => Promise<void>;
  setEditableRow: (rowId: number | null) => void;
  loading: boolean;
};

export const ActionColumn = ({ editableRow, row, onSave, onDiscard, handleDelete, setEditableRow, loading }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Space style={{ columnGap: "5px", display: "flex", justifyContent: "end" }}>
      <PermissionCheck permissionKeys={[PermissionNames.FIXTURE]} permissionOptions={[PermissionOperations.UPDATE]}>
        <div style={{ display: "flex" }}>
          {editableRow === row.id ? (
            <>
              <Button
                size="small"
                type="text"
                icon={<i className="fas fa-check mr-2" />}
                onClick={() => {
                  onSave();
                }}
              />
              <Button
                size="small"
                type="text"
                icon={<i className="fas fa-xmark mr-2" />}
                onClick={() => {
                  onDiscard();
                }}
              />
            </>
          ) : (
            <Button
              size="small"
              type="text"
              icon={<i className="fas fa-pen mr-2" />}
              title={formatMessage({ id: "table.column.actions.inlineEdit" })}
              disabled={editableRow !== null && editableRow !== row.id}
              onClick={() => {
                setEditableRow(row.id);
              }}
            />
          )}
          <EditBroadcastAction loading={loading} onSave={onSave} editableRow={editableRow} row={row} />
          <DeleteBroadcastAction
            disabled={editableRow !== null && editableRow !== row.id}
            onDelete={async (row: BroadcastTableRow) => {
              await handleDelete(row);
            }}
            record={row}
          />
        </div>
      </PermissionCheck>
    </Space>
  );
};
